import { convertDatePtBr } from "../../../utils/convertDatePtBr";

export const ACTIVITY_TYPE_OPTIONS = [
  "Parecer",
  "Certificação",
  "Relatório de Vídeo",
  "Relatório de Texto",
];

export const normalizeText = (value) =>
  (value ?? "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    // Treat "-" as "/" so date searches work with either separator (10-02-2019 == 10/02/2019).
    .replace(/-/g, "/")
    // Drop ordinal indicators so "1º"/"1ª" reduce to just "1".
    .replace(/[ºª°]/g, "")
    // Accept a missing space between a word and a number, e.g. "cap1"/"bloco22" == "cap 1"/"bloco 22".
    .replace(/([a-z])(\d)/g, "$1 $2");

const buildItemLevelHaystack = (item) =>
  normalizeText(
    [item?.user?.name, item?.type?.value, convertDatePtBr(item?.doneDateTime)]
      .filter(Boolean)
      .join(" ")
  );

const buildAttachmentHaystack = (attachment) => {
  const version = attachment?.version;

  return normalizeText(
    [
      attachment?.chapterNumber != null && `Cap ${attachment.chapterNumber}`,
      attachment?.blockNumber != null && `Bloco ${attachment.blockNumber}`,
      // Covers "1º/1ª/1 Versão", "1a Versão" and "Versão 1" search variants.
      version != null &&
        `${version} Versão ${version}a Versão Versão ${version}`,
    ]
      .filter(Boolean)
      .join(" ")
  );
};

export const matchesSearch = (item, searchTerm) => {
  const terms = (searchTerm ?? "")
    .split("+")
    .map((term) => normalizeText(term.trim()))
    .filter(Boolean);

  if (!terms.length) return true;

  const itemHaystack = buildItemLevelHaystack(item);
  // An activity can bundle several attachments (e.g. Cap 1..6 in one go). Combined "+" terms
  // like "Cap 8 + 2 Versão" must all be satisfied by the SAME attachment, not by different
  // ones (an activity with Cap 8/1ª Versão and, separately, Cap 3/2ª Versão shouldn't match).
  const attachments = item?.attachments?.length ? item.attachments : [null];

  return attachments.some((attachment) => {
    const haystack = `${itemHaystack} ${buildAttachmentHaystack(attachment)}`;
    return terms.every((term) => haystack.includes(term));
  });
};

export const matchesTypeFilter = (item, selectedTypes) =>
  !selectedTypes.length || selectedTypes.includes(item?.type?.value);

export const filterActivities = (list, { searchTerm, selectedTypes }) =>
  (list ?? []).filter(
    (item) =>
      matchesTypeFilter(item, selectedTypes) && matchesSearch(item, searchTerm)
  );
